import { render, staticRenderFns } from "./positionPannel.vue?vue&type=template&id=54fb44b8&"
import script from "./positionPannel.vue?vue&type=script&lang=js&"
export * from "./positionPannel.vue?vue&type=script&lang=js&"
import style0 from "./positionPannel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports